import script from "./RelatedDoctorComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatedDoctorComponent.vue?vue&type=script&setup=true&lang=js"

import "./RelatedDoctorComponent.vue?vue&type=style&index=0&id=4edcb41e&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4edcb41e"]])

export default __exports__